import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3695d9d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "experience-search__section-wrapper" }
const _hoisted_2 = { class: "experience-search__section" }
const _hoisted_3 = { class: "experience-search__section__date" }
const _hoisted_4 = { class: "experience-search__title" }
const _hoisted_5 = { class: "experience-search__date-controls" }
const _hoisted_6 = {
  key: 0,
  class: "experience-search__availabilities-loading"
}
const _hoisted_7 = { class: "experience-search__section__participants" }
const _hoisted_8 = { class: "experience-search__title" }
const _hoisted_9 = { class: "experience-search__quantity-wrapper" }

import BaseIcon from '@/components/BaseIcon.vue'
import BaseButton from '@/components/BaseButton.vue'
import DatePicker from '@/components/DatePicker.vue'
import AlertBanner from '@/components/AlertBanner.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import BaseNumberIncrementer from '@/components/BaseNumberIncrementer.vue'
import ExperienceAvailabilityPicker from '@/components/public/ExperienceAvailabilityPicker.vue'
import { FORMATS, SIZES, ALERT_TYPES } from '@/enums/components'
import { computed, onMounted, PropType, reactive, ref, watch } from 'vue'
import { StringDate } from '@/models/shared.model'
import { useFetchExperiencePeriodAvailability } from '@/queries/public/services'
import { formatDateTime } from '@/utils/formatters'
import {
  ExperiencePeriodAvailability,
  ExperiencePeriodAvailabilitySearch,
  PublicServiceDetails,
} from '@/models/public/service.model'
import { useOrderStore } from '@/store/order'
import format from 'date-fns/format'
import endOfMonth from 'date-fns/endOfMonth'
import { serviceResultCardCommonProps } from '@/enums/public'


const enum CALENDAR_STATE {
  PREVIOUS = 'PREVIOUS',
  CURRENT = 'CURRENT',
  NEXT = 'NEXT',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienceSearch',
  props: {
  selectedDate: {
    type: Date as PropType<Date | null>,
    default: null,
  },
  selectedGroupSize: {
    type: Number as PropType<number | undefined>,
    default: undefined,
  },
  service: {
    type: Object as PropType<PublicServiceDetails>,
    required: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  groupService: serviceResultCardCommonProps.groupService,
  time: {
    type: String,
    default: null,
  },
  duration: {
    type: Number,
    default: null,
  },
  excludedReservations: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
},
  emits: ['fetchInfo'],
  setup(__props, { emit }) {

const props = __props

const orderStore = useOrderStore()



const currentCalendarAvailability = ref<ExperiencePeriodAvailability[]>([])
const previewCalendarAvailability = ref<ExperiencePeriodAvailability[]>([])
const err = ref(false)

const errors = ref<Record<string, unknown> | undefined>(undefined)

const currentState = reactive({
  pickerYearMonth: {
    instance: 0,
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  },
  selectedDate: props.selectedDate,
  group_size: props.selectedGroupSize ?? props.service?.min_group_size,
})

const previewState = reactive({
  pickerYearMonth: {
    instance: 0,
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  },
  selectedDate: null,
})

const currentAvailableDates = computed<StringDate[]>(() => {
  const availabilities = currentCalendarAvailability.value || []

  const dates = availabilities
    .filter((item: ExperiencePeriodAvailability) => item.is_available)
    .map((item: ExperiencePeriodAvailability) => item.date)

  return dates
})

const previewAvailableDates = computed<StringDate[]>(() => {
  const availabilities = previewCalendarAvailability.value || []

  const dates = availabilities
    .filter((item: ExperiencePeriodAvailability) => item.is_available)
    .map((item: ExperiencePeriodAvailability) => item.date)

  return dates
})

const selectedDateIndex = computed(() => {
  return currentAvailableDates.value.findIndex(
    (date) => date === formatDateTime(currentState.selectedDate, 'yyyy-mm-dd'),
  )
})

const {
  mutateAsync: fetchExperiencePeriodAvailability,
  isLoading: isLoadingExperiencePeriodAvailability,
} = useFetchExperiencePeriodAvailability(props.service.hash_id)

const getIsDateDisabled = (date: Date): boolean => {
  if (isLoadingExperiencePeriodAvailability.value) return true
  const dateStr: StringDate = formatDateTime(date)
  return !previewAvailableDates.value.includes(dateStr)
}

const fetchPeriodAvailability = (calendarState: CALENDAR_STATE) => {
  changeMonth(calendarState)
  const firstDayOfMonth = new Date(
    previewState.pickerYearMonth.year,
    previewState.pickerYearMonth.month,
    1,
  )

  const payload = {
    start: format(firstDayOfMonth, 'yyyy-MM-dd'),
    end: format(endOfMonth(firstDayOfMonth), 'yyyy-MM-dd'),
    group_size: props.service?.min_group_size,
    group_service: props.groupService,
  }
  fetchExperiencePeriodAvailability(payload)
    .then((data) => {
      if (!currentCalendarAvailability.value.length) {
        // Initialize state
        currentCalendarAvailability.value = data
      }
      previewCalendarAvailability.value = data
    })
    .then(() => {
      fetchResponseHandler(calendarState)
    })
    .catch((error) => {
      currentCalendarAvailability.value = []
      return error
    })
}

function synchronizePreviewState() {
  if (currentState.selectedDate) {
    previewCalendarAvailability.value = currentCalendarAvailability.value
    previewState.pickerYearMonth.month = currentState.selectedDate.getMonth()
    previewState.pickerYearMonth.year = currentState.selectedDate.getFullYear()
  }
}

function periodSelected(value: Date) {
  err.value = false
  previewState.selectedDate = value
  currentCalendarAvailability.value = previewCalendarAvailability.value
  Object.assign(currentState, previewState)
}

function changeMonth(calendarState: CALENDAR_STATE) {
  if (calendarState === CALENDAR_STATE.CURRENT) return
  else if (calendarState === CALENDAR_STATE.PREVIOUS) {
    if (currentState.pickerYearMonth.month === 0)
      currentState.pickerYearMonth.month = 11
    else currentState.pickerYearMonth.month -= 1
  } else if (calendarState === CALENDAR_STATE.NEXT) {
    if (currentState.pickerYearMonth.month === 11)
      currentState.pickerYearMonth.month = 0
    else currentState.pickerYearMonth.month += 1
  }
}

function previousDate() {
  err.value = false
  if (!currentState.selectedDate) return null
  emit('fetchInfo', null)
  // Check if the current selected date is first in the list
  if (selectedDateIndex.value <= 0) {
    // Change month and avaible dates. Preselect next date and refetech avaiable dates
    fetchPeriodAvailability(CALENDAR_STATE.PREVIOUS)
  } else {
    const newDate = new Date(
      currentAvailableDates.value[selectedDateIndex.value - 1],
    )
    currentState.selectedDate = newDate
    synchronizePreviewState()
  }
}

function nextDate() {
  err.value = false
  if (!currentState.selectedDate) return null
  emit('fetchInfo', null)
  // Check if the current selected date is last in the list
  if (selectedDateIndex.value === currentAvailableDates.value.length - 1) {
    // Change month and avaible dates. Preselect next date and refetech avaiable dates
    fetchPeriodAvailability(CALENDAR_STATE.NEXT)
  } else {
    const newDate = new Date(
      currentAvailableDates.value[selectedDateIndex.value + 1],
    )
    currentState.selectedDate = newDate
    synchronizePreviewState()
  }
}

function fetchResponseHandler(claendartState: CALENDAR_STATE) {
  if (!previewAvailableDates.value.length) {
    let newDate = null
    if (claendartState === CALENDAR_STATE.NEXT) {
      newDate = previewCalendarAvailability.value[0].date
    } else {
      newDate =
        previewCalendarAvailability.value[
          previewCalendarAvailability.value.length - 1
        ].date
    }
    periodSelected(new Date(newDate))
    err.value = true
  } else if (claendartState !== CALENDAR_STATE.CURRENT) {
    let newDate = null
    if (claendartState === CALENDAR_STATE.NEXT) {
      newDate = previewAvailableDates.value[0]
    } else {
      newDate =
        previewAvailableDates.value[previewAvailableDates.value.length - 1]
    }
    periodSelected(new Date(newDate))
  }
}

watch(
  () => props.selectedDate,
  () => {
    currentState.selectedDate = props.selectedDate
  },
)

watch(
  () => props.selectedGroupSize,
  () => {
    currentState.group_size = props.selectedGroupSize
  },
)

watch([() => currentState.selectedDate, () => currentState.group_size], () => {
  const payload: ExperiencePeriodAvailabilitySearch = {
    start: null,
    end: null,
    group_size: currentState.group_size,
  }
  if (currentState.selectedDate) {
    payload.start = currentState.selectedDate
  }
  orderStore.updateAvailabilitySearch(payload)
})

onMounted(() => {
  // const sessionPayload = sessionStorage.getItem('availiability-search')
  // if (sessionPayload) {
  //   const payload: ExperiencePeriodAvailabilitySearch =
  //     JSON.parse(sessionPayload)
  //   if (payload.start) {
  //     currentState.selectedDate = new Date(payload.start)
  //   }
  //   currentState.group_size = payload.group_size
  // }
  fetchPeriodAvailability(CALENDAR_STATE.CURRENT)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('whenAreYouGoing')), 1),
        (currentState.selectedDate && err.value)
          ? (_openBlock(), _createBlock(AlertBanner, {
              key: 0,
              text: _ctx.$t('noAvaiableDatesInMonth'),
              "alert-type": _unref(ALERT_TYPES).WARNING
            }, null, 8, ["text", "alert-type"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BaseButton, {
            format: _unref(FORMATS).ICON_CIRCULAR,
            size: _unref(SIZES).SMALL,
            "icon-size": 32,
            disabled: 
              !currentState.selectedDate ||
              _unref(isLoadingExperiencePeriodAvailability)
            ,
            type: "button",
            icon: "chevron-left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (previousDate()))
          }, null, 8, ["format", "size", "disabled"]),
          _createVNode(DatePicker, {
            "model-value": currentState.selectedDate,
            "min-date": new Date(),
            "month-change-on-scroll": false,
            "month-change-on-arrows": false,
            "disabled-dates": getIsDateDisabled,
            disabled: __props.isDisabled,
            placeholder: _ctx.$t('selectDate'),
            "keep-action-row": "",
            clearable: "",
            class: _normalizeClass(["experience-search__date-input", {
              'experience-search__input--error': errors.value?.start || errors.value?.end,
            }]),
            name: "period",
            errors: [...(errors.value?.start as Array<string> || []), ...(errors.value?.end as Array<string> || [])],
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => periodSelected(value)),
            onUpdateMonthYear: _cache[2] || (_cache[2] = 
              (value) => (
                (previewState.pickerYearMonth = value),
                fetchPeriodAvailability(CALENDAR_STATE.CURRENT)
              )
            ),
            onClosed: _cache[3] || (_cache[3] = ($event: any) => (synchronizePreviewState()))
          }, {
            "action-preview": _withCtx(() => [
              (_unref(isLoadingExperiencePeriodAvailability))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(LoadingSpinner),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('experienceSearch.calendarLoading')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            "action-buttons": _withCtx(() => []),
            "clear-icon": _withCtx(() => [
              (_unref(isLoadingExperiencePeriodAvailability))
                ? (_openBlock(), _createBlock(LoadingSpinner, {
                    key: 0,
                    class: "experience-search__loading"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model-value", "min-date", "disabled", "placeholder", "class", "errors"]),
          _createVNode(BaseButton, {
            format: _unref(FORMATS).ICON_CIRCULAR,
            size: _unref(SIZES).SMALL,
            "icon-size": 32,
            disabled: 
              !currentState.selectedDate ||
              _unref(isLoadingExperiencePeriodAvailability)
            ,
            "icon-right": "",
            type: "button",
            icon: "chevron-right",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (nextDate()))
          }, null, 8, ["format", "size", "disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t('howManyAreYou')), 1),
        _createVNode(BaseNumberIncrementer, {
          amount: currentState.group_size,
          errors: errors.value?.group_size,
          "min-amount": __props.service.min_group_size,
          "max-amount": __props.service.max_group_size,
          disabled: __props.isDisabled,
          class: "experience-search__input",
          onClickMinus: _cache[5] || (_cache[5] = _withModifiers(() => (currentState.group_size -= 1), ["prevent"])),
          onClickPlus: _cache[6] || (_cache[6] = _withModifiers(() => (currentState.group_size += 1), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(BaseIcon, {
                size: 20,
                icon: "user"
              }),
              _createTextVNode("x " + _toDisplayString(currentState.group_size), 1)
            ])
          ]),
          _: 1
        }, 8, ["amount", "errors", "min-amount", "max-amount", "disabled"])
      ])
    ]),
    (currentState.selectedDate && _unref(currentAvailableDates).length)
      ? (_openBlock(), _createBlock(ExperienceAvailabilityPicker, {
          key: 0,
          service: __props.service,
          date: currentState.selectedDate,
          "group-size": currentState.group_size,
          time: __props.time,
          duration: __props.duration,
          disabled: __props.isDisabled,
          "excluded-reservations": __props.excludedReservations,
          onFetchInfo: _cache[7] || (_cache[7] = (payload) => emit('fetchInfo', payload))
        }, null, 8, ["service", "date", "group-size", "time", "duration", "disabled", "excluded-reservations"]))
      : _createCommentVNode("", true)
  ]))
}
}

})